import { useContext } from 'react';
import { MediaContext } from '../media-context';

export const useMedia = () => {
  const ctx = useContext(MediaContext);
  if (!ctx) throw new Error('useMedia must be used inside <MediaProvider>');
  return ctx;
};
